const ListCustomized = ({ items }) => {

  const splitList = (item) => {
    if (item.indexOf(":") > -1) {
      const splitItem = item.split(":");
      if (splitItem.length === 2)
        return <><strong>{splitItem[0]}:</strong>{splitItem[1]}</>;
    }
    return item;
  }

  return (
    <ul className="experience-list">
      {items.map((item, index) => ( 
        <li key={index}>{splitList(item)}</li>
      ))}
    </ul>
  );
};

export default ListCustomized;